import {useMemo} from "react";
import {useIntl} from "react-intl";
import {useAppSelector} from "hooks/useAppSelector";
import {getRewardLevelName} from "app/utils/help";

export const useRewardProgressData = () => {
    const userData = useAppSelector((state) => state.user.user);
    const vipList = useAppSelector((state) => state.config.platformConfig?.vipList);
    const {$t} = useIntl();

    const revard = useMemo(() => {
        const currentVip = vipList?.find((v) => v.level === userData?.level);
        const nextLevel = (userData?.level || 1) + 1;

        const matchName = currentVip?.name?.match(/^([^\d]+)\s*(\d+)$/);

        return {
            name: matchName ? $t({id: String(matchName[1].trim() || "")}) + " " + matchName[2] : $t({id: "Rookie"}),
            nameOriginal: currentVip?.name || $t({id: "Rookie"}),
            icon: getRewardLevelName(currentVip?.name || "Rookie"),
            title: currentVip?.name || $t({id: "Rookie"}),
            xp: {
                current: userData?.exp || 0,
                max: vipList?.find((v) => v.level === nextLevel)?.exp || userData?.exp || 0,
            },
        };
    }, [userData, vipList]);

    const nextRevard = useMemo(() => {
        const nextLevel = (userData?.level || 1) + 1;
        const nextVip = vipList?.find((v) => v.level === nextLevel);

        const matchName = nextVip?.name?.match(/^([^\d]+)\s*(\d+)$/);

        return {
            name: matchName ? $t({id: String(matchName[1].trim() || "")}) + " " + matchName[2] : "",
            nameOriginal: nextVip?.name || "",
            icon: getRewardLevelName(nextVip?.name || ""),
            title: nextVip?.name || "",
            xp: {
                current: 0,
                max: 0,
            },
        };
    }, []);

    return {
        revard,
        nextRevard,
    };
};
